// import { svg4everybody } from '../vendor/svg4everybody';
import { handleLoggedIn, handleGoldUser, handlePrivatePerson } from './handler';
export { fallback, methods };

// usage: log('inside coolFunc',this,arguments);
// http://paulirish.com/2009/log-a-lightweight-wrapper-for-consolelog/
window.log = function () {
	log.history = log.history || []; // store logs to an array for reference
	log.history.push(arguments);
	// if (this.console) {
	// 	console.log(Array.prototype.slice.call(arguments));
	// }
};

window.onload = function onLoad() {
	if (USER_ID > 0) {
		handleLoggedIn();
	}

	handleGoldUser();
	handlePrivatePerson();
};

// svg4everybody(); //svg support for older browsers
// This is not some kind of polyfill! It's just to prevent old browsers from failing horribly
var fallback = function () {
};
var methods = ['assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log', 'profile', 'profileEnd', 'time', 'timeEnd', 'timeStamp', 'trace', 'warn', 'table'];

if (typeof console === 'undefined') {
	var console = {};
}

for (var i in methods) {
	if (typeof console[methods[i]] === 'undefined') {
		console[methods[i]] = fallback;
	}
}